import { cn } from '@/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import type { PropsWithChildren } from 'react';

type DataListBaseProps = {
    className?: string;
} & PropsWithChildren;

type DataListItemProps = DataListBaseProps;
export const DataListItem = ({ children, className }: DataListItemProps) => {
    return <div className={cn('col-span-2 grid grid-cols-subgrid gap-4', className)}>{children}</div>;
};

type DataListLabelProps = DataListBaseProps;
export const DataListLabel = ({ children, className }: DataListLabelProps) => {
    return <dt className={cn('text-sm text-neutral-500 leading-none', className)}>{children}</dt>;
};

type DataListValueProps = DataListBaseProps;
export const DataListValue = ({ children, className }: DataListValueProps) => {
    return <dd className={cn('text-sm text-neutral-950 leading-none', className)}>{children}</dd>;
};

const listVariants = cva(['grid gap-2'], {
    variants: {
        variant: {
            default: 'grid-cols-[auto_1fr]',
            stretched: 'grid-cols-[1fr_auto]',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

type DataListProps = DataListBaseProps & VariantProps<typeof listVariants>;
export const DataList = ({ children, variant, className }: DataListProps) => {
    return <dl className={listVariants({ variant, className })}>{children}</dl>;
};

DataList.Item = DataListItem;
DataList.Label = DataListLabel;
DataList.Value = DataListValue;
